

import {
  app as appShare,
  wechat as wechatShare
} from '../../components/Share';
import {getTitle, getShareOptions} from '../../helpers/trip';
import Detector from '../../utils/detector';

const isWechat = Detector.browser.name === 'weixin';

export function init(trip){
  if(isWechat){
    wechat(trip);
  }
}

export function app(trip) {
  let config = getShareConfig(trip);

  appShare(config);
}

export function wechat(trip) {
  let config = getShareConfig(trip);

  wechatShare(config);
}


function getShareConfig(trip) {
  let tripTitle = getTitle(trip);
  let result = getShareOptions(trip);

  if (!isMyTrip()) {
    result.content = `发现这个【${tripTitle}】规划的不错，你也来看看吧！`;
  }

  console.log(result);

  return result;
}


function isMyTrip() {
  return [
    'tantumap',
    'tantutravel',
    'zuzuche',
    'zuzuchepro'
  ].indexOf(Detector.browser.name) !== -1;
}



// WEBPACK FOOTER //
// ./src/pages/trip/share.js